import { create } from 'zustand';

interface User {
  readonly id: string;
  readonly email: string;
  readonly name: string | null;
}

interface AuthState {
  readonly user: User | null;
  readonly accessToken: string | null;
  readonly isAuthenticated: boolean;
  readonly isLoading: boolean;

  readonly login: (user: User, accessToken: string, refreshToken: string) => void;
  readonly setUser: (user: User | null) => void;
  readonly setLoading: (loading: boolean) => void;
  readonly logout: () => void;
  readonly restoreSession: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  accessToken: null,
  isAuthenticated: false,
  isLoading: true,

  login: (user, accessToken, refreshToken) => {
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('refreshToken', refreshToken);
    localStorage.setItem('user', JSON.stringify(user));
    set({ user, accessToken, isAuthenticated: true, isLoading: false });
  },

  setUser: (user) => set({ user, isAuthenticated: user !== null, isLoading: false }),
  setLoading: (isLoading) => set({ isLoading }),

  logout: () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user');
    set({ user: null, accessToken: null, isAuthenticated: false });
  },

  restoreSession: () => {
    const token = localStorage.getItem('accessToken');
    const userStr = localStorage.getItem('user');
    if (token && userStr) {
      try {
        const user = JSON.parse(userStr) as User;
        set({ user, accessToken: token, isAuthenticated: true, isLoading: false });
        return;
      } catch {
        // invalid stored data
      }
    }
    set({ isLoading: false });
  },
}));
